import { http } from '../utils/http';
import { Response } from '../types/resp';

export const wp = {
	options: async (): Promise<any> => {
		return http.get<Response<any>>(window.location.origin + '/wp-json/tm-super/v1/options')
	},
	optionKey: async (key: string): Promise<any> => {
		return http.get<Response<any>>(window.location.origin + '/wp-json/tm-super/v1/option/' + key)
	}
}
